// extracted by mini-css-extract-plugin
export default {"body":"Oss_body__v+mPy","license":"Oss_license__++Nvo","licenseBody":"Oss_licenseBody__3vYTY","component":"Oss_component__AKl6Y","detailsHeader":"Oss_detailsHeader__2R9kw"};